import { InjectStyle } from '../../types'
const rules: (arg: InjectStyle) => string[] = ({ blockClass, mode }: InjectStyle) => {
  const result = [
    `iframe, .${blockClass} { background: #ccc }`,
    'noscript { display: none !important; }'
  ]
  if (mode === 'page') {
    result.push('.mem-replayer-show { display: block !important; }')
    result.push('.mem-replayer-hide { display: none !important; }')
    result.push('::-webkit-scrollbar { display: none; }')
  }
  return result
}

export default rules;
